<template>
  <Modal title="Title" v-model="showFormModal" class-name="card-modal" :width="450">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>
    <Form ref="question" :model="question" :rules="ruleValidate" :label-width="100">
      <Row class="widget-container">

        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Import List" align="left">
            <Button @click="addChoiceList" icon="ios-add-circle-outline" type="primary" title="Add Choice List"
                    size="small" v-show="!addChoices">
              Import Choice List
            </Button>
            <Input v-model="choiceList" type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                   placeholder="Enter List" v-show="addChoices">
            </Input>
            <Button @click="importChoiceList" icon="ios-add-circle-outline" type="primary" title="Import List"
                    size="small" v-show="addChoices">
              Add
            </Button>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Title" :prop="title" align="left">
            <Label>{{question.title}}</Label>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Allow Other" align="left">
            <i-switch v-model="question.allowOther"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem :label="'Choice ' + ix" style="margin-bottom: 20px;"
                    v-for="(choice, ix) in question.choices" :key="ix" :prop="'choices[' + ix + '].label'"
                    :rules="{required: true, message: 'Choice ' + ix +' cannot be empty', trigger: 'blur'}">
            <Row>
              <i-col :xs="20" :sm="20" :md="20" :lg="20">
                <Input v-model="choice.label"
                       :key="ix" style="width: 100%;"
                       :placeholder="'Choice ' + ix"
                       :type="'text'">
                </Input>
              </i-col>
              <i-col :xs="4" :sm="4" :md="4" :lg="4">
                <Button icon="ios-remove-circle-outline" type="error" @click="removeChoice(ix)"
                        title="Remove" size="small"/>
              </i-col>
            </Row>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem>
            <i-col :xs="24" :sm="24" :md="24" :lg="24" align="right">
              <Button @click="addChoice" icon="ios-add-circle-outline" type="primary" title="Add New Choice"
                      size="small">
                Add
              </Button>
            </i-col>
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button size="large" @click="handleReset;showFormModal=false" style="margin-left: 8px">
        Cancel
      </Button>
      <Button size="large" class="submit" type="success" v-if="action=='edit'"
              @click="handleUpdate">Save
      </Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    data() {
      return {
        init: null,
        index: 0,
        action: 'add',
        title: 'ADD FORM',
        showFormModal: false,
        question: {
          index: 0,
          status: 0,
          allowOther: false,
          fieldCode: '',
          formId: 0,
          inputType: '',
          order: 0,
          questionId: 0,
          title: '',
          type: '',
          visible: false,
          choices: [{
            actionOnSync: null,
            choiceId: 0,
            label: '',
            order: 0,
            questionId: 0
          }]
        },
        ruleValidate: {},
        spinShow: true,
        choiceList: null,
        addChoices: false,
      }
    },
    methods: {
      openChoices() {
        this.handleReset();
        this.showFormModal = true;
        this.title = 'Edit Choices';
        this.action = 'edit';
      },
      setFormValue(formDataList, index) {
        this.init = formDataList[index];
        let question = formDataList[index];
        if (!question.choices) {
          question.choices = [];
        }
        let data = Object.assign({}, question);
        this.question = data;
      },
      handleUpdate() {
        this.$refs['question'].validate((valid) => {
          if (valid) {
            this.showFormModal = false;
          }
        });
      },
      handleReset() {
        this.question = this.init;
      },
      addChoice() {
        let newRow = {
          questionId: this.question.questionId,
          choiceId: parseInt(this.question.questionId.toString() + this.question.choices.length.toString()),
          label: '',
          actionOnSync: '',
          order: this.question.choices.length + 1,
          status: false
        };
        this.question.choices.push(newRow);
      },
      addChoiceList() {
        this.addChoices = true;
      },
      importChoiceList() {
        if (this.choiceList) {
          let list = this.choiceList.trim().replace(/\n/g, ",").trim().split(',');
          for (let i = 0; i < list.length; i++) {
            let newRow = {
              questionId: this.question.questionId,
              choiceId: parseInt(this.question.questionId.toString() + this.question.choices.length.toString()),
              label: list[i],
              actionOnSync: '',
              order: this.question.choices.length + 1,
              status: false
            };
            this.question.choices.push(newRow);
          }
        }
        this.choiceList = null;
        this.addChoices = false;
      },
      removeChoice(choiceIndex) {
        this.question.choices.splice(choiceIndex, 1);
      },
      getTimeStamp() {
        let dt = Math.floor(Math.random() * Math.floor(4000000));
        return dt;
      }
    }
  }
</script>
<style scoped>
  .ivu-input, .ivu-btn {
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/d_MyQuestionnaireForms/_surveyChoicesForm.vue